module.exports = __webpack_public_path__ + "images/icons/flags/PT-2aa1c719.svg";